import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Calendar, MapPin, Tag } from 'lucide-react';
import { toast } from 'sonner';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { api, fmtUSD } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { SecurityBanner } from '@/components/SecurityBanner';

export default function RequestDetailPage() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get(`/requests/${id}`).then((res) => setR(res.data)); }, [id]);

  const propose = async () => {
    if (!user) { toast.error('Connectez-vous'); return nav('/login'); }
    if (user.role !== 'jobeur') { toast.error('Seuls les jobeurs peuvent proposer'); return; }
    const res = await api.post('/conversations', {
      other_user_id: r.client_id,
      request_id: r.id,
      initial_message: `Bonjour, je suis intéressé par votre demande « ${r.title} ». Je peux vous aider.`,
    });
    nav(`/messages/${res.data.conversation.id}`);
  };

  if (!r) return <div className="max-w-3xl mx-auto p-6">Chargement…</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 space-y-4" data-testid="request-detail-page">
      <Card className="p-6">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-1 text-xs bg-[#EAF3FF] text-[#0E3F80] px-2 py-0.5 rounded-full border border-[#C7E2FF]"><Tag size={11} /> {r.category}</span>
          {r.urgent && <span className="text-[10px] font-bold bg-[#CE1021] text-white px-2 py-0.5 rounded-full uppercase">Urgent</span>}
        </div>
        <h1 className="text-2xl md:text-3xl font-bold mt-2">{r.title}</h1>
        <div className="mt-2 text-sm text-slate-600 flex flex-wrap gap-3">
          <span className="flex items-center gap-1"><MapPin size={14} /> {r.commune}, {r.city}</span>
          {r.desired_date && <span className="flex items-center gap-1"><Calendar size={14} /> {r.desired_date}</span>}
        </div>
        <p className="mt-4 text-slate-700 leading-relaxed whitespace-pre-wrap">{r.description}</p>
        <div className="mt-6 flex items-center justify-between border-t border-[#E2E8F0] pt-4">
          <div>
            <p className="text-xs text-slate-600">Budget indicatif</p>
            <p className="text-2xl font-bold font-mono-num text-[#1677F2]">{r.budget_cents ? fmtUSD(r.budget_cents) : 'À négocier'}</p>
          </div>
          {user?.role === 'jobeur' && <Button onClick={propose} className="bg-[#1677F2] hover:bg-[#0F5FCC]" data-testid="request-propose-btn">Proposer mes services</Button>}
        </div>
      </Card>
      <SecurityBanner variant="compact" />
    </div>
  );
}
